"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = exports.SlideImage = exports.SlideTitle = exports.SlideCaption = exports.SliderWrapper = exports.InnerContainer = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  .carousel-control-prev {\n    opacity: 0;\n    width: auto;\n    left: 25px;\n  }\n  .carousel-control-next {\n    opacity: 0;\n    width: auto;\n    right: 25px;\n  }\n  @media ", " {\n    &:hover .carousel-control-prev,\n    &:hover .carousel-control-next {\n      opacity: 1;\n    }\n  }\n"], ["\n  .carousel-control-prev {\n    opacity: 0;\n    width: auto;\n    left: 25px;\n  }\n  .carousel-control-next {\n    opacity: 0;\n    width: auto;\n    right: 25px;\n  }\n  @media ", " {\n    &:hover .carousel-control-prev,\n    &:hover .carousel-control-next {\n      opacity: 1;\n    }\n  }\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n  max-width: ", "px;\n  width: calc(100% - 30px);\n  @media ", " {\n    max-width: ", "px;\n  }\n  ", ";\n  ", "\n\n  .content {\n    color: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n  max-width: ", "px;\n  width: calc(100% - 30px);\n  @media ", " {\n    max-width: ", "px;\n  }\n  ", ";\n  ", "\n\n  .content {\n    color: ", ";\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n          right: 15px;\n          left: auto;\n          text-align: right;\n        "], ["\n          right: 15px;\n          left: auto;\n          text-align: right;\n        "]),
    _templateObject5 = _taggedTemplateLiteral(["\n          left: 15px;\n          right: 15px;\n          max-width: none;\n          text-align: center;\n          margin: 0 auto;\n        "], ["\n          left: 15px;\n          right: 15px;\n          max-width: none;\n          text-align: center;\n          margin: 0 auto;\n        "]),
    _templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  text-transform: ", ";\n  font-weight: ", ";\n  @media ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  color: ", ";\n  text-transform: ", ";\n  font-weight: ", ";\n  @media ", " {\n    font-size: ", ";\n  }\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  min-height: 250px;\n  max-height: 600px;\n  object-fit: cover;\n\n  @media ", " {\n    min-height: auto;\n  }\n"], ["\n  min-height: 250px;\n  max-height: 600px;\n  object-fit: cover;\n\n  @media ", " {\n    min-height: auto;\n  }\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  font-weight: ", ";\n  position: relative;\n  padding-bottom: 6px;\n  transition: all 0.4s ease-in-out;\n  &:after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    background: #fff;\n    height: 1px;\n    width: 20px;\n    left: 0%;\n    transition: all 0.4s ease-in-out;\n  }\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n  &:hover:after {\n    background: ", ";\n    width: 99%;\n  }\n"], ["\n  font-size: ", ";\n  color: ", ";\n  font-weight: ", ";\n  position: relative;\n  padding-bottom: 6px;\n  transition: all 0.4s ease-in-out;\n  &:after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    background: #fff;\n    height: 1px;\n    width: 20px;\n    left: 0%;\n    transition: all 0.4s ease-in-out;\n  }\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n  &:hover:after {\n    background: ", ";\n    width: 99%;\n  }\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globalCss = require("../../../styles/globalCss");

var variable = _interopRequireWildcard(_globalCss);

var _colors = require("../../../styles/colors");

var colors = _interopRequireWildcard(_colors);

var _breakpoints = require("../../../styles/breakpoints");

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InnerContainer = exports.InnerContainer = (0, _styledComponents2.default)(_reactBootstrap.Container)(_templateObject);

var SliderWrapper = exports.SliderWrapper = _styledComponents2.default.div(_templateObject2, _breakpoints2.default.tabletL);

var SlideCaption = exports.SlideCaption = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.maxWidth || "280";
}, _breakpoints2.default.tablet, function (props) {
  return props.maxWidth || "600";
}, function (props) {
  return props.contentPosition === "right" ? (0, _styledComponents.css)(_templateObject4) : {};
}, function (props) {
  return props.contentPosition === "center" ? (0, _styledComponents.css)(_templateObject5) : {};
}, function (props) {
  return props.color || colors.whiteColor;
});

var SlideTitle = exports.SlideTitle = _styledComponents2.default.h2(_templateObject6, function (props) {
  return props.titleFontSize || variable.H3;
}, function (props) {
  return props.titleColor || colors.whiteColor;
}, function (props) {
  return props.textTransform || "uppercase";
}, function (props) {
  return props.fontWeight || "600";
}, _breakpoints2.default.tablet, function (props) {
  return props.titleFontSize || "35px";
});

var SlideImage = exports.SlideImage = _styledComponents2.default.img(_templateObject7, _breakpoints2.default.tablet);

var Link = exports.Link = _styledComponents2.default.a(_templateObject8, function (props) {
  return props.linkFontSize || variable.baseFont;
}, function (props) {
  return props.linkColor || {};
}, function (props) {
  return props.fontWeight || {};
}, function (props) {
  return props.linkHoverColor || colors.whiteColor;
}, function (props) {
  return props.lineColor || colors.whiteColor;
});